import React from 'react';
import styled from 'styled-components';
import Product from '../product/Product';

const Wrapper = styled.div`
  .container {
    max-width: 1300px !important;
  }

  /* .filters-wrapper {
    min-height: 230px;
  } */

  .product-container {
    margin-top: 50px;
    display: grid;
    grid-template-columns: ${({ doubleGrid }) =>
      doubleGrid ? '1fr 1fr' : '1fr'};
    grid-gap: 40px;
  }

  .second-subtitle {
    margin-top: 90px;
    font-size: 35px;
    line-height: 45px;
  }

  @media (max-width: 992px) {
    .second-subtitle {
      padding: 0 15px;
      font-size: 25px;
      line-height: 30px;
    }
  }
`;

function FeaturedProducts({
  doubleGrid,
  handleToggleSideCart,
  title,
  featuredProducts
}) {
  if (!featuredProducts.length) return ``;

  return (
    <Wrapper doubleGrid={doubleGrid}>
      {title && <h2 className="second-subtitle">{title}</h2>}

      <div className="pillow-bundles-container product-container container">
        {featuredProducts.map(product => {
          const subcategory = product.frame.subcategories[0];
          return (
            <Product
              loadingProducts={false}
              selectedFabricId={null}
              key={product.id}
              name={subcategory.name}
              products={[product]}
              doubleGrid={doubleGrid}
              averageRating={subcategory.avg_rating}
              totalReviews={subcategory.total_reviews}
              handleToggleSideCart={handleToggleSideCart}
            />
          );
        })}
      </div>
    </Wrapper>
  );
}

export default FeaturedProducts;
